export const policiesForAllNodes = [
  {
    value: "i-policies-for-all",
    label: "I. Middlebury-Wide Policies",
    className: "i-policies-for-all",
    children: [
      {
        value: "i-policies-for-all/genl-principles",
        label: "A. General Principles",
        className: "genl-principles",
        children: [
          {
            value: "i-policies-for-all/genl-principles/respectful-behavior",
            label: "A.1. Respectful Behavior",
            className: "respectful-behavior",
          },
          {
            value: "i-policies-for-all/genl-principles/honesty-cooperation",
            label: "A.2. Honesty and Cooperation in Middlebury Matters",
            className: "honesty-cooperation",
          },
          {
            value:
              "i-policies-for-all/genl-principles/non-discrimination-statement",
            label: "A.3. Non-discrimination Statement",
            className: "non-discrimination-statement",
          },
          {
            value: "i-policies-for-all/genl-principles/envl-sustain-policy",
            label: "A.4. Environmental and Sustainability Policy",
            className: "envl-sustain-policy",
          },
          {
            value: "i-policies-for-all/genl-principles/freedom-of-expression",
            label: "A.5. Policy on Open Expression",
            className: "freedom-of-expression",
          },
        ],
      },
      {
        value: "i-policies-for-all/non-discrim-policies",
        label: "B. Non-Discrimination Policies",
        className: "non-discrim-policies",
        children: [
          {
            value:
              "i-policies-for-all/non-discrim-policies/b-1-a-non-discrimination-policy",
            label: "B.1.a. Non-Discrimination Policy",
            className: "b-1-a-non-discrimination-policy",
          },
          {
            value:
              "i-policies-for-all/non-discrim-policies/anti-harassment-discrimin",
            label:
              "B.1.b. Non-Discrimination Investigations & Resolutions Procedure",
            className: "anti-harassment-discrimin",
          },
          {
            value:
              "i-policies-for-all/non-discrim-policies/b-1-b-2-2020-tix-investigation-resolutions-procedure",
            label: "B.1.b (1). TIX Investigation & Resolutions Procedure",
            className: "b-1-b-2-2020-tix-investigation-resolutions-procedure",
          },
          {
            value: "i-policies-for-all/non-discrim-policies/ada-policy",
            label: "B.1.c. Americans with Disabilities Act Policy",
            className: "ada-policy",
          },
          {
            value: "i-policies-for-all/non-discrim-policies/svc-assist-animals",
            label: "B.1.d. Service and Assistance Animals Policy",
            className: "svc-assist-animals",
          },
        ],
      },
      {
        value: "i-policies-for-all/health-safety",
        label: "C. Health & Safety Policies",
        className: "health-safety",
        children: [
          {
            value: "i-policies-for-all/health-safety/emerg-prepare",
            label:
              "C.1. Emergency Preparedness for Middlebury Schools and Programs",
            className: "emerg-prepare",
          },
          {
            value: "i-policies-for-all/health-safety/tam-policy",
            label: "C.2. Threat Assessment and Response Policy",
            className: "tam-policy",
          },
          {
            value: "i-policies-for-all/health-safety/emerg-removals",
            label: "C.3. Emergency Removals Policy",
            className: "emerg-removals",
          },
          {
            value: "i-policies-for-all/health-safety/demonst-protests",
            label: "C.4. Demonstration and Protest Regulations",
            className: "demonst-protests",
          },
          {
            value: "i-policies-for-all/health-safety/minors-on-campus",
            label: "C.5. Minors on Campus Policy",
            className: "minors-on-campus",
          },
          {
            value: "i-policies-for-all/health-safety/weapons",
            label: "C.6. Weapons Policy",
            className: "weapons",
          },
          {
            value: "i-policies-for-all/health-safety/alcohol-drugs",
            label: "C.7. Alcohol, Tobacco and Other Drugs",
            className: "alcohol-drugs",
          },
          {
            value: "i-policies-for-all/health-safety/no-smoking",
            label: "C.8. No Smoking Policy",
            className: "no-smoking",
          },
          {
            value: "i-policies-for-all/health-safety/camping-overnight-occupancy",
            label: "C.9 Camping/Overnight Occupancy of Unauthorized Locations",
            className: "camping-overnight-occupancy",
          },
          {
            value: "i-policies-for-all/health-safety/cameras-on-campus",
            label: "C.10 Cameras on Campus",
            className: "cameras-on-campus",
          }
        ],
      },
      {
        value: "i-policies-for-all/appropriate-use",
        label: "D. Appropriate Use of Middlebury Resources and Assets",
        className: "appropriate-use",
        children: [
          {
            value: "i-policies-for-all/appropriate-use/steward-resources",
            label:
              "D.1. Stewarding Middlebury Resources and Financial Policies",
            className: "steward-resources",
          },
          {
            value: "i-policies-for-all/appropriate-use/id-cards",
            label: "D.2. ID Cards",
            className: "id-cards",
          },
          {
            value: "i-policies-for-all/appropriate-use/library-resources",
            label: "D.3. Library",
            className: "library-resources",
          },
          {
            value: "i-policies-for-all/appropriate-use/intell-property",
            label: "D.4. Intellectual Property",
            className: "intell-property",
          },
          {
            value: "i-policies-for-all/appropriate-use/info-tech",
            label: "D.5. Information Technology",
            className: "info-tech",
          },
          {
            value:
              "i-policies-for-all/appropriate-use/d-6-whistleblower-policy",
            label: "D.6. Whistleblower Policy",
            className: "d-6-whistleblower-policy",
          },
          {
            value:
              "i-policies-for-all/appropriate-use/d-7-policy-on-scheduling-middlebury-space-for-events",
            label: "D.7. Policy on Scheduling Middlebury Space for Events",
            className: "d-7-policy-on-scheduling-middlebury-space-for-events",
          },
          {
            value:
              "i-policies-for-all/appropriate-use/posters",
            label: "D.8. Posters, Chalking, Banners and Other Displays",
            className: "posters",
          }
        ],
      },
      {
        value: "i-policies-for-all/records",
        label: "E. Records",
        className: "records",
        children: [
          {
            value: "i-policies-for-all/records/ferpa",
            label: "E.1. Student Privacy Rights Under U.S. Federal Law (FERPA)",
            className: "ferpa",
          },
          {
            value: "i-policies-for-all/records/student-data-for-research",
            label: "E.2. Access to Student Data for Research",
            className: "student-data-for-research",
          },
          {
            value: "i-policies-for-all/records/student-location-determination-policy",
            label: "E.3 Student Location Determination Policy",
            className: "student-location-determination-policy",
          },
        ],
      },
      {
        value: "i-policies-for-all/f-required-disclosures",
        label: "F. Required Disclosures",
        className: "f-required-disclosures",
      },
      {
        value: "i-policies-for-all/g-misconduct-in-research",
        label: "G. Misconduct in Research and Other Scholarly Activities",
        className: "g-misconduct-in-research",
      },
      {
        value: "i-policies-for-all/h-information-technology",
        label: "H. Information Technology",
        className: "h-information-technology",
        children: [
          {
            value: "i-policies-for-all/h-information-technology/h-1-info-tech-overview",
            label: "H.1. Information Technology Overview",
            className: "h-1-info-tech-overview"
          },
          {
            value: "i-policies-for-all/h-information-technology/h-2-responsible-use-policy",
            label: "H.2. Responsible Use Policy",
            className: "h-2-responsible-use-policy"
          },
          {
            value: "i-policies-for-all/h-information-technology/h-3-privacy-and-security-policy",
            label: "H.3. Privacy and Security Policy",
            className: "h-3-privacy-and-security-policy"
          }
        ]
      }
    ],
  }
]